class Parallax {
  constructor() {
    this.body = document.querySelector('body');
    this.images = document.querySelectorAll('.ns-parallax-img');

    const parallaxElements = document.querySelectorAll('.ns-parallax')

    // The parallax function
    const parallax = elements => {
        if ('undefined' !== elements && elements.length > 0) {
          elements.forEach( element => {
            let y = window.pageYOffset;
            if (y > 0) {
              if(element.classList.contains('ns-parallax-bottom')) {
                element.style.transform = 'translate3d(0, -' + (0.2 * y) + 'px ,0)'
              } else if(element.classList.contains('ns-parallax-middle')) {
                element.style.transform = 'translate3d(0, -' + (0.3 * y) + 'px ,0)'
              } else {
                element.style.transform = 'translate3d(0, -' + (0.1 * y) + 'px ,0)'
              }
            }
          })
        }
      }

    //If element is in viewport, set its position
    parallax(parallaxElements)

    //Call the function on scroll
    window.onscroll = () => {
        parallax(parallaxElements)
    }
  }
}
export default Parallax;
